(function () {
    'use strict';

    angular.module('swif.interventions')
    .config(route)
    .controller('InterConfigurationController', InterConfigurationController)
    .controller('InterInterventionCategoriesController', InterInterventionCategoriesController)
    .controller('InterTaskCategoriesController', InterTaskCategoriesController)
    .controller('InterAbsenceCategoriesController', InterAbsenceCategoriesController)
    .controller('InterRequestTemplateController', InterRequestTemplateController)
    .controller('InterRequestTemplateModalController', InterRequestTemplateModalController)
    .controller('InterRequestPriorityController', InterRequestPriorityController)
    .controller('InterRequestCommunicationChannelController', InterRequestCommunicationChannelController)
    .controller('InterParamsController', InterParamsController)
    .controller('TasksRangesController', TasksRangesController)
    .controller('TaskTemplateModalController', TaskTemplateModalController)
    .controller('InterventionsTemplatesController', InterventionsTemplatesController);

    function route ($routeProvider) {
        $routeProvider.when('/interventions/configuration_view', {
            templateUrl: 'partials/openstc/configuration_view.html',
            controller: 'InterConfigurationController',
            reloadOnSearch: false,
            resolve: {
                data: ['swifRouteService', function (route) {
                    return route.check();
                }]
            }
        });
    }

    function InterConfigurationController ($scope, $q, swif, userService, gettextCatalog) {
        'ngInject';
        console.log('init InterConfigurationController');
        swif.settings.page.title = 'Interventions module configuration';
        $scope.modules = swif.module.modules;
        $scope.loading = {items: {}};
        $scope.refresh = refresh;
        $scope.access_rights = userService.getAccessRights();
        $scope.stateFilterChoices = [];

        function refresh () {
            swif.message.loading($scope.loading.items);
            var deferred = [];
            _.forEach([
                'intervention_categories',
                'task_categories',
                'absence_categories',
                'intervention_request_priorities',
                'intervention_request_communication_channels',
                'tasks_ranges',
                'interventions_templates'
            ], function (name) {
                var collection = swif.collection.getCollection(name);
                if (collection) {
                    deferred.push(collection.getItems());
                }
            });
            $q.all(deferred).then(function () {
                swif.message.loading($scope.loading.items, 'ok');
            }, function () {
                swif.message.loading($scope.loading.items, 'ko');
            });
        }

        function initialize() {
            var stateFilterChoices = [];

            var states = swif.settings.getContentType('intervention_request').states;
            angular.forEach(states, function(state, key) {
                stateFilterChoices.push({id: key, name: gettextCatalog.getString(state.title)});
            });

            $scope.stateFilterChoices = stateFilterChoices;
        }
        initialize();
    }

    function InterInterventionCategoriesController ($scope, swif) {
        'ngInject';
        console.log('init InterventionCategoriesController');
        var filter = {};
        swif.data.sortOn(filter, 'id', 'ASC');
        swif.collections.createOrUpdate(
            'intervention_categories',
            'intervention_category',
            filter
        ).then(function (collection) {
            $scope.intervention_categories = collection;
        });
        $scope.preModal = function (data) {
            $scope.intervention_categories.preModal(data);
        };
        $scope.preValidate = function (data) {
            return $scope.intervention_categories.preValidate(data);
        };
        $scope.callback = function (error, data) {
            $scope.intervention_categories.defaultActionCallback(error, data);
        };
    }

    function InterTaskCategoriesController ($scope, swif) {
        'ngInject';
        console.log('init TaskCategoriesController');
        var filter = {};
        swif.data.sortOn(filter, 'id', 'ASC');
        swif.collections.createOrUpdate(
            'task_categories',
            'task_category',
            filter
        ).then(function (collection) {
            $scope.task_categories = collection;
        });
        $scope.preModal = function (data) {
            $scope.task_categories.preModal(data);
        };
        $scope.preValidate = function (data) {
            return $scope.task_categories.preValidate(data);
        };
        $scope.callback = function (error, data) {
            $scope.task_categories.defaultActionCallback(error, data);
        };
    }

    function InterAbsenceCategoriesController($scope, swif) {
        'ngInject';
        console.log('init InterAbsenceCategoriesController');
        var filter = {};
        swif.data.sortOn(filter, 'id', 'ASC');
        swif.collections.createOrUpdate(
            'absence_categories',
            'absence_category',
            filter
        ).then(function (collection) {
            $scope.absence_categories = collection;
        });
        $scope.preModal = function (data) {
            $scope.absence_categories.preModal(data);
        };
        $scope.preValidate = function (data) {
            return $scope.absence_categories.preValidate(data);
        };
        $scope.callback = function (error, data) {
            $scope.absence_categories.defaultActionCallback(error, data);
        };
    }

    function InterRequestTemplateController($q, $scope, $sce, swif, swifOpenbaseService) {
        'ngInject';
        console.log('init InterRequestTemplateController');
        var filter = {};
        swif.data.sortOn(filter, 'sequence', 'ASC');
        swif.collections.createOrUpdate(
            'intervention_request_categories',
            'intervention_request_category',
            filter
        ).then(function (collection){
            if($scope.opengst_mobile_module){
                $scope.getPictograms().then(function(){
                    $scope.intervention_request_categories = collection;
                });
            }else{
                $scope.intervention_request_categories = collection;
            }
        });
        $scope.formatName = function(item){
            if (item) {
                let item_str = '<span title="picto"><svg height="60" width="60" xml:space="preserve" viewBox="0 0 960 35"><path d="'+ item.image_coor +'" /></svg>';
                item_str = item['name'] ? '<span title="text">' + item_str + ' ' + item.name + '</span>' : item_str;
                item_str += '</span>';
                return $sce.trustAsHtml(item_str);
            }
        }
        $scope.preModal = function (data) {
            $scope.intervention_request_categories.preModal(data);
        };
        $scope.preValidate = function (data) {
            return $scope.intervention_request_categories.preValidate(data);
        };
        $scope.callback = function (error, data) {
            $scope.intervention_request_categories.defaultActionCallback(error, data);
        };

        $scope.pictograms_selector = {};
        $scope.pictograms = [];
        $scope.opengst_mobile_module = swif.module.modules.opengst_mobile;

        $scope.displayPicto = function(item){
            return $scope.formatName($scope.pictograms_selector[item[0]]);
        }

        $scope.getPictograms = function(){
            let filter = {};
            swif.data.sortOn(filter, 'name', 'asc');
            swif.data.setLimit(filter, 300);
            return swif.data.get('mobile_pictogram', undefined, filter).then(
                function (pictograms) {
                    _.forEach(pictograms, function(element){
                        $scope.pictograms.push(element);
                        $scope.pictograms_selector[element.id] = {
                            image_coor: element.image_coor
                        };
                    })
                }
            );
        }

        $scope.goUp = function (templateToGoUp, index) {
            let indexUp = index-1;
            let templateToGoDown = $scope.intervention_request_categories.items[indexUp];

            swif.data.callKw('intervention_request_category', 'move_up', [templateToGoUp.id])
                .then(function (results) {
                    //we move up the element in the array
                    let eltToMove = _.remove($scope.intervention_request_categories.items,
                        function(template) {return template.id === templateToGoUp.id; });
                    swifOpenbaseService.utils.insertItemInArray($scope.intervention_request_categories.items, indexUp, eltToMove[0]);
                });
        };
        $scope.goDown = function (templateToGoDown, index) {
            let indexDown = index+1;
            let templateToGoUp = $scope.intervention_request_categories.items[indexDown];

            swif.data.callKw('intervention_request_category', 'move_down', [templateToGoDown.id])
                .then(function (results) {
                    // we move up the element in the array
                    let eltToMove = _.remove($scope.intervention_request_categories.items,
                        function(template) {return template.id === templateToGoDown.id; });
                    swifOpenbaseService.utils.insertItemInArray($scope.intervention_request_categories.items, indexDown, eltToMove[0]);
                });
        };
    }

    function InterRequestTemplateModalController($scope, openstc, swifOpenbaseCompanyService) {
        'ngInject';
        console.log('init InterRequestTemplateModalController');
        var filters = openstc.request.getFilters({});
        $scope.filters = filters;
        swifOpenbaseCompanyService.getGlobalSettings().then(function(company) {
            $scope.processingTimesEnable = company.processing_times_enable
        });
    }

    function InterRequestPriorityController($scope, swif) {
        'ngInject';
        console.log('init InterRequestPriorityController');
        var filter = {};
        swif.data.sortOn(filter, 'id', 'ASC');
        swif.collections.createOrUpdate(
            'intervention_request_priorities',
            'intervention_request_priority',
            filter
        ).then(function (collection) {
            $scope.intervention_request_priorities = collection;
        });
        $scope.preModal = function (data) {
            $scope.intervention_request_priorities.preModal(data);
        };
        $scope.preValidate = function (data) {
            return $scope.intervention_request_priorities.preValidate(data);
        };
        $scope.callback = function (error, data) {
            $scope.intervention_request_priorities.defaultActionCallback(error, data);
        };
    }

    function InterRequestCommunicationChannelController($scope, swif) {
        'ngInject';
        console.log('init InterRequestCommunicationChannelController');

        var filter = {};

        swif.data.sortOn(filter, 'id', 'ASC');

        swif.collections.createOrUpdate(
            'intervention_request_communication_channels',
            'intervention_request_communication_channel',
            filter
        ).then(function (collection) {
            $scope.intervention_request_communication_channels = collection;
        });

        $scope.preModal = function (data) {
            $scope.intervention_request_communication_channels.preModal(data);
        };

        $scope.preValidate = function (data) {
            if (data.action.id === "set_default") {
                return swif.data.callKw(
                    'intervention_request_communication_channel',
                    'set_default',
                    [data.model.id]
                );
            } else if (data.action.id === "unset_default") {
                data.model.default = false;
            }
            return $scope.intervention_request_communication_channels.preValidate(data);
        };

        $scope.callback = function (error, data) {
            $scope.intervention_request_communication_channels.defaultActionCallback(error, data);

            // Refresh list on default update
            if (_.contains(['set_default', 'unset_default'], data.action.id)) {
                $scope.intervention_request_communication_channels.refresh()
            }
        };
    }

    function InterParamsController($scope, swif, swifOpenbaseCompanyService) {
        'ngInject';
        console.log('init InterParamsController');

        swifOpenbaseCompanyService.getGlobalSettings().then(function(company) {
            $scope.globalSettings = company;
        });

        $scope.modules = swif.module.modules;

        $scope.saveGlobalSettings = function () {
            //sanitize
            if ($scope.globalSettings.state_default_filters === undefined){
                $scope.globalSettings.state_default_filters = false;
            }
            swifOpenbaseCompanyService.saveCompany($scope.globalSettings);
        };

        $scope.$watch('globalSettings.request_priority_enable', function(newV, oldV) {
            if (!newV && oldV){
                //user has disable priority
                $scope.globalSettings.request_priority_require = false;
            }
        });

        $scope.$watch('globalSettings.request_priority_require', function(newV, oldV) {
            if (newV && !oldV){
                //user has make priority require
                $scope.globalSettings.request_priority_require = true;
            }
        });

        $scope.$watch('globalSettings.request_report_date_enable', function(newV, oldV) {
            if (!newV && oldV){
                $scope.globalSettings.request_report_date_replace = false;
            }
        });

        $scope.$watch('globalSettings.request_report_date_replace', function(newV, oldV) {
            if (newV && !oldV){
                $scope.globalSettings.request_report_date_replace = true;
            }
        });

        $scope.$watch('globalSettings.task_patrimony_tab_enable', function(newV, oldV) {
            if (!newV && oldV){
                //user has disable the tab
                $scope.globalSettings.task_patrimony_tab_required = false;
            }
        });

        $scope.$watch('globalSettings.task_notify', function(newV, oldV) {
            if (!newV && oldV){
                //user has disable the tab
                $scope.globalSettings.task_notify_default_value = false;
            }
        });
    }

    function TasksRangesController($scope, swifFrameworkService, swifOpenbaseService) {
        'ngInject';
        console.log('init TasksRangesController');

        var swif = swifFrameworkService;
        var filters = {
            tasksRanges: {}
        };

        // Load tasks ranges
        swif.collections.createOrUpdate(
            'tasks_ranges',
            'task_range',
            filters.tasksRanges
        ).then(function (collection) {
            $scope.tasksRanges = collection;
        });

        $scope.loading = {tasksTemplates: {}};

        $scope.preModal = function(data) {
            $scope.tasksRanges.preModal(data);
        }
        $scope.preValidate = function(data) {
            return $scope.tasksRanges.preValidate(data);
        }
        $scope.callback = function(error, data) {
            $scope.tasksRanges.defaultActionCallback(error, data);
        }
        $scope.preModalTask = function(data) {
            $scope.tasksTemplates.preModal(data);
        };
        $scope.preValidateTask = function(data) {
            data.model.task_range_id = [$scope.tasksRanges.currentItem.id, $scope.tasksRanges.currentItem.name];
            return $scope.tasksTemplates.preValidate(data);
        }
        $scope.callbackTask = function(error, data) {
            $scope.tasksTemplates.defaultActionCallback(error, data);
        }

        // Get tasks templates on click on task range
        $scope.$watch('tasksRanges.currentItem', function(newV, oldV) {
            if (!_.isUndefined(newV) && ((!_.isUndefined(oldV) && newV.id !== oldV.id) || _.isUndefined(oldV))) {
                swif.message.loading($scope.loading.tasksTemplates);

                var filter = {};
                swif.data.addExtraFilter(filter, 'tasksTemplates', 'task_range_id', '=', newV.id);
                swif.data.sortOn(filter, 'sequence', 'ASC');
                swif.collections.createOrUpdate(
                    'tasks_templates',
                    'task_template',
                    filter
                ).then(function (collection) {
                    $scope.tasksTemplates = collection;
                    swif.message.loading($scope.loading.tasksTemplates, 'ok');
                }, function () {
                    swif.message.loading($scope.loading.tasksTemplates, 'ko');
                });
            }
        });

        $scope.goUp = function (taskToGoUp, index) {
            let indexUp = index-1;
            let taskToGoDown = $scope.tasksTemplates.items[indexUp];

            swif.data.callKw('task_template', 'move_up', [taskToGoUp.id])
                .then(function (results) {
                    // Move up the element in the array
                    let eltToMove = _.remove($scope.tasksTemplates.items,
                        function(task) { return task.id === taskToGoUp.id; });
                    swifOpenbaseService.utils.insertItemInArray($scope.tasksTemplates.items, indexUp, eltToMove[0]);
                });
        };
        $scope.goDown = function (taskToGoDown, index) {
            let indexDown = index+1;
            let taskToGoUp = $scope.tasksTemplates.items[indexDown];

            swif.data.callKw('task_template', 'move_down', [taskToGoDown.id])
                .then(function (results) {
                    // Move up the element in the array
                    let eltToMove = _.remove($scope.tasksTemplates.items,
                        function(task) { return task.id === taskToGoDown.id; });
                    swifOpenbaseService.utils.insertItemInArray($scope.tasksTemplates.items, indexDown, eltToMove[0]);
                });
        };
    }

    function TaskTemplateModalController($scope, swifFrameworkService, swifOpenbaseCompanyService, gettextCatalog) {
        'ngInject';
        console.log('init TaskTemplateModalController');
        var swif = swifFrameworkService;
        // Retreive current task range to get it's services ids
        var taskRanges = swif.collection.getCollection('tasks_ranges');
        $scope.helpText = '';

        // differentiation of cases : creation or update from task_ranges or intervention_templates view
        if ($scope.model.task_range_id) {
            $scope.fromTaskRange = true;
            $scope.helpText = gettextCatalog.getString('Categories are sorted by range\'s departments');
        } else if ($scope.model.project_template_id) {
            taskRanges.currentItem = {};
            $scope.fromTaskRange = false;
        }
        if (!_.isUndefined(taskRanges.currentItem) && !$scope.model.project_template_id) {
            $scope.model.service_ids = taskRanges.currentItem.service_ids;
            if ($scope.model.service_ids) {
                $scope.helpText = gettextCatalog.getString('Categories are sorted by range\'s departments');
            }
            $scope.fromTaskRange = true;
        }
        $scope.blankTask = function () {
            $scope.fromTaskRange = false;
        }


        $scope.getFilters = function () {
            $scope.filters = {
                task_category: {},
                service_ids: {},
                user_id: {},
                team_id: {},
                partner_id: {}
            };
            swif.data.addFilter($scope.filters.user_id, 'is_assignable_to_task', '=', true);
            swif.data.addFilter($scope.filters.partner_id, 'type_id.service_supplier', '=', true);
            if ($scope.model.service_ids && $scope.model.service_ids.length > 0) {
                swif.data.addFilter($scope.filters.task_category, '|');
                swif.data.addFilter($scope.filters.task_category, 'service_ids', '=', false);
                swif.data.addFilter($scope.filters.task_category, 'service_ids', 'in', $scope.model.service_ids);
                swif.data.addFilter($scope.filters.user_id, 'service_id', 'in', $scope.model.service_ids);
                swif.data.addFilter($scope.filters.team_id, 'manager_id.service_id', 'in', $scope.model.service_ids);
            }
        }
        $scope.getFilters();

        // Set configured task duration in settings (only at creation)
        swifOpenbaseCompanyService.getGlobalSettings().then(function (company) {
            if (!$scope.model.planned_hours) {
                $scope.model.planned_hours = company.task_default_hours;
            }
        });
    }

    function InterventionsTemplatesController($scope, swifFrameworkService, swifOpenbaseService) {
        console.log('init InterventionsTemplatesController');

        var swif = swifFrameworkService;
        var filter = {};

        // Load tasks ranges
        swif.collections.createOrUpdate(
            'interventions_templates',
            'intervention_template',
            filter
        ).then(function (collection) {
            $scope.interventionsTemplates = collection;
        });

        $scope.loading = {tasksTemplates: {}};

        $scope.preModal = function(data) {
            $scope.interventionsTemplates.preModal(data);
        }
        $scope.preValidate = function(data) {
            return $scope.interventionsTemplates.preValidate(data);
        }
        $scope.callback = function(error, data) {
            $scope.interventionsTemplates.defaultActionCallback(error, data);
        }
        $scope.preModalTask = function(data) {
            if (data.action.id === 'add-to-inter') {
                var project_template_id = [data.model.id, data.model.name];
                data.model = {};
                data.model.project_template_id = project_template_id;
            }
            $scope.tasksTemplates.preModal(data);
        }
        $scope.preValidateTask = function(data) {
            var choice = data.model._creationChoice;
            delete data.model._creationChoice;
            var res;
            if (choice === 'select') {
                res = swif.data.callKw('task_template', 'create_from_task_range', [data.model.task_range[0]], {project_template_id: data.model.project_template_id[0]});
            } else if (choice === 'form') {
                res = swif.data.create('task_template', data.model);
            } else {
                res = $scope.tasksTemplates.preValidate(data);
            }
            return res;
        }
        $scope.callbackTask = function(error, data) {
            if (data.action.id === 'add-to-inter') {
                $scope.tasksTemplates.getItems(); // Reload collection with freshly created items
            }
            $scope.tasksTemplates.defaultActionCallback(error, data);
        }

        // Get tasks templates on click on task range
        $scope.$watch('interventionsTemplates.currentItem', function(newV, oldV) {
            if (!_.isUndefined(newV) && ((!_.isUndefined(oldV) && newV.id !== oldV.id) || _.isUndefined(oldV))) {
                swif.message.loading($scope.loading.tasksTemplates);

                var filter = {};
                swif.data.addExtraFilter(filter, 'tasksTemplates', 'project_template_id', '=', newV.id);
                swif.data.sortOn(filter, 'sequence', 'ASC');
                swif.collections.createOrUpdate(
                    'tasks_templates',
                    'task_template',
                    filter
                ).then(function (collection) {
                    $scope.tasksTemplates = collection;
                    swif.message.loading($scope.loading.tasksTemplates, 'ok');
                }, function () {
                    swif.message.loading($scope.loading.tasksTemplates, 'ko');
                });
            }
        });

        $scope.goUp = function (taskToGoUp, index) {
            let indexUp = index-1;
            let taskToGoDown = $scope.tasksTemplates.items[indexUp];

            swif.data.callKw('task_template', 'move_up', [taskToGoUp.id])
                .then(function (results) {
                    // Move up the element in the array
                    let eltToMove = _.remove($scope.tasksTemplates.items,
                        function(task) { return task.id === taskToGoUp.id; });
                    swifOpenbaseService.utils.insertItemInArray($scope.tasksTemplates.items, indexUp, eltToMove[0]);
                });
        };
        $scope.goDown = function (taskToGoDown, index) {
            let indexDown = index+1;
            let taskToGoUp = $scope.tasksTemplates.items[indexDown];

            swif.data.callKw('task_template', 'move_down', [taskToGoDown.id])
                .then(function (results) {
                    // Move up the element in the array
                    let eltToMove = _.remove($scope.tasksTemplates.items,
                        function(task) { return task.id === taskToGoDown.id; });
                    swifOpenbaseService.utils.insertItemInArray($scope.tasksTemplates.items, indexDown, eltToMove[0]);
                });
        };
    }

})();
